import ServicePageTemplate from "../components/ServicePageTemplate";
import { IMAGES } from "../data/business";
import { SERVICES } from "../data/services";

export default function PodologyPage() {
  return (
    <ServicePageTemplate
      service={SERVICES.podology}
      heroImage={IMAGES.podiatry}
      secondaryImage={IMAGES.podiatryAlt}
      breadcrumbLabel="Podologia"
      bullets={[
        "Podolog z doświadczeniem — indywidualny plan leczenia dla każdego pacjenta.",
        "Bezinwazyjne leczenie wrastających paznokci klamrami ortonyksyjnymi.",
        "Sprzęt medyczny, zdezynfekowane narzędzia, jednorazowe frezy.",
        "Terapia brodawek wirusowych i wsparcie w leczeniu grzybicy paznokci.",
        "Dyskrecja i komfort — także dla pacjentów z cukrzycą i seniorów.",
      ]}
      finalSection={{ title: "Podolog w Katowicach, który słucha, tłumaczy i skutecznie leczy." }}
    />
  );
}
